// @flow

export { getWeekDay } from './get-week-day';
export { getWeekDayByCountry } from './get-week-day-by-country';
